<template>
  <div class="companyBox">
    <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
      <Form-item label="所属集团公司：" prop="companyName">
        <Input
          v-model="formCustom.companyName"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="考勤年月：" prop="attendanceDate">
        <DatePicker
          v-model="formCustom.attendanceDate"
          type="month"
        />
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')"
        >重置
        </Button
        >
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button type="primary" @click="addOrganization()">新建</Button>
    </div>
    <div>
      <Table
        :columns="companyColumns"
        :data="companyTableData"
        :loading="loading"
        aria-describedby=""
        aria-hidden="true"
        border @on-selection-change="selectionChange"
      >
        <template slot="action" slot-scope="{ row }">
          <Button
            size="small"
            type="text"
            @click="check(row)"
          >查看
          </Button>
          <Button
            size="small"
            type="text"
            @click="editOrganization(row)"
          >编辑
          </Button
          >
        </template>
        <template slot="auditStatus" slot-scope="{ row }">
          {{
            row.auditStatus == 1 ? '草稿' : row.auditStatus == 2 ? '待审核' : row.auditStatus == 3 ? '审核通过' : '审核拒绝'
          }}
        </template>
      </Table>
      <Page
        ref="pages"
        :current="page"
        :total="total"
        class="page_position"
        show-elevator
        show-sizer
        show-total
        @on-change="setCurrent"
        @on-page-size-change="setPage"
      ></Page>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="审核" width="500px">
      <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
        <FormItem label="审核结果：">
          <el-radio v-model="asyncRoute.pass" label="1">审核通过</el-radio>
          <el-radio v-model="asyncRoute.pass" label="2">审核拒绝</el-radio>
        </FormItem>
        <Form-item label="审核意见：">
          <Input
            v-model="asyncRoute.checkIdea"
            clearable
            style="width: 200px"
            type="textarea"
          ></Input>
        </Form-item>
      </Form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="auditclick">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogTableVisible" title="考勤配置" width="850px">
      <el-tabs>
        <el-tab-pane label="职工表">
          <Table
            :border="true"
            :columns="columns"
            :data="tableData"
            aria-describedby="" aria-hidden="true"
          >
          </Table>
          <Page
            ref="dialogpages"
            :current="dialogpage"
            :total="dialogtotal"
            class="page_position"
            show-elevator
            show-sizer
            show-total
            @on-change="dialogsetCurrent"
            @on-page-size-change="dialogsetPage"
          ></Page>
        </el-tab-pane>
        <el-tab-pane label="节假日及考勤上传截止时间">
          <p>节假日：</p>
          <el-calendar v-model="attendanceDate">
            <template
              slot="dateCell"
              slot-scope="{date, data}"
            >
              <button
                :class="daylist.indexOf(data.day) != -1 ? 'green' : holidaylist.indexOf(data.day) != -1 ? 'red' : '' "
                :disabled="data.day.split('-')[1] != row.attendanceDate.split('-')[1]"
                style="width: 100%;height: 100%;"
              >
                <p :class="data.isSelected ? 'is-selected' : ''">
                  {{ data.day.split('-').slice(2).join('-') }}
                </p>
                <p>
                  {{ daylist.indexOf(data.day) != -1 ? '假日' : '' }}
                </p>
                <p>
                  {{ holidaylist.indexOf(data.day) != -1 ? '法定节日' : '' }}
                </p>
              </button>
            </template>
          </el-calendar>
          <p>考勤上传截止时间：{{ row.cutoffTime }}</p>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import permissionList from "@/libs/handlePermission.ts";
import {
  companyAttendanceAudit,
  companyAttendanceCancelSubmit,
  companyAttendanceConfigDetail,
  companyAttendanceConfigPage,
  companyAttendanceSubmitAudit,
  companyEmployeePage
} from "@/api/attendance";
import axios from 'axios'

export default {
  name: "company",
  data() {
    return {
      dialogVisible: false,
      dialogTableVisible: false,
      tableData: [],
      total: 0,
      page: 1,
      dialogtotal: 0,
      dialogpage: 1,
      dialogloading: false,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      companyIds: "",
      formCustom: {},
      asyncRoute: {
        pass: '1',
        checkIdea: ''
      },
      attendanceDate: '',
      companyColumns: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属集团公司", key: "companyName", align: "center"},
        {title: "考勤年月", key: "attendanceDate", align: "center"},
        {title: "在职人数", key: "employeeNumber", align: "center"},
        {title: "法定节日天数", key: "holidayDays", align: "center"},
        {title: "假日天数", key: "weekendDays", align: "center"},
        {title: "考勤上传截止日期", key: "cutoffTime", align: "center"},
        {title: "配置导入时间", key: "createTime", align: "center"},
        {title: "配置更新时间", key: "modifyTime", align: "center"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      columns: [
        {type: "index", title: "序号", align: "center"},
        {title: "所属企业", key: "companyName", align: "center"},
        {title: "所属厂站", key: "deptName", align: "center"},
        {title: "姓名", key: "employeeRealName", align: "center"},
        {title: "身份证号", key: "employeeIdNumber", align: "center"},
        {title: "职位", key: "employeePositionName", align: "center"},
      ],
      companyTableData: [], // 表格数据
      row: {},
      areaData: [],
      countyCode: "",
      industryTypeList: [], // 行业类型
      companyScaleList: [], // 企业规模
      addDialogVisible: false,
      editDialogVisible: false,
      roleType: '',
      companyAttendanceIds: '',
      val: new Date(),
      daylist: [],
      holidaylist: [],
      cutoffTime: ''
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString);
    this.roleType = user.roleType;
    console.log(this.roleType)
  },
  methods: {
    // 初始化
    init() {
      this.loading = true

      companyAttendanceConfigPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res);
      });
    },
    selectionChange(rows) {
      if (rows && rows.length > 0) {
        let ids = [];
        rows.forEach((row) => {
          ids.push(row.companyAttendanceId);
        });
        this.companyAttendanceIds = ids.join(",");
      } else {
        this.companyAttendanceIds = ''
      }
    },
    check(row) {//查看详情
      this.row = row
      companyEmployeePage({
        companyAttendanceConfigId: row.companyAttendanceConfigId,
        current: 1,
        size: 10
      }).then((res) => {
        this.dialogchangeData(res);
        this.dialogTableVisible = true
      });
      companyAttendanceConfigDetail(row.companyAttendanceConfigId).then((res) => {
        this.cutoffTime = res.data.data.cutoffTime
        this.holidaylist = res.data.data.holidayConfig || []
        this.daylist = res.data.data.weekendConfig || []
        this.attendanceDate = res.data.data.attendanceDate
      })
    },
    // 查询
    handleSearch() {
      this.loading = true
      companyAttendanceConfigPage({
        current: 1,
        size: this.pageSize,
        attendanceDate: this.formCustom.attendanceDate && this.$moment(this.formCustom.attendanceDate).format('YYYY-MM'),
        companyName: this.formCustom.companyName,
        attendanceNumber: this.formCustom.attendanceNumber,
        auditStatus: this.formCustom.auditStatus
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total;
      this.size = res.data.data.size;
      this.companyTableData = res.data.data.records;
      this.loading = false;
    },
    dialogchangeData(res) {
      this.dialogtotal = res.data.data.total;
      this.dialogsize = res.data.data.size;
      this.tableData = res.data.data.records;
      this.dialogloading = false;
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields();
      // 重置查询条件会再次查询
      this.handleSearch();
    },

    // 改变页码
    dialogsetCurrent(val) {
      this.dialogloading = true;
      this.dialogpage = val;
      companyEmployeePage({
        current: val,
        size: this.pageSize,
        companyAttendanceConfigId: this.row.companyAttendanceConfigId,
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    // 改变每页条数
    dialogsetPage(val) {
      this.dialogloading = true;
      this.pageSize = val;
      companyEmployeePage({
        current: 1,
        size: this.pageSize,
        companyAttendanceConfigId: this.row.companyAttendanceConfigId,
      }).then((res) => {
        this.dialogchangeData(res);
        this.$refs["dialogpages"].currentPage = 1; // 分页变成第一页
      });
    },
    setCurrent(val) {
      this.loading = true
      const data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.page = val;
      companyAttendanceConfigPage({
        current: val,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
      });
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      const data = {
        ...this.formCustom,
      };
      this.loading = true;
      this.pageSize = val;
      companyAttendanceConfigPage({
        current: 1,
        size: this.pageSize,
        ...data,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    changeCountyCode(v, d) {
      this.countyCode = d.slice(-1)[0].id;
    },
    addOrganization() {
      this.$router.push({
        path: '/companyAttendance/uploadConfiguration'
      })
    },
    editOrganization(row) {
      this.$router.push({
        path: '/companyAttendance/uploadConfiguration',
        query: {
          companyAttendanceConfigId: row.companyAttendanceConfigId,
          attendanceDate: row.attendanceDate,
          companyId: row.companyId,
          companyName: row.companyName
        }
      })
    },
    cancelSubmit(row) {
      companyAttendanceCancelSubmit({
        companyAttendanceId: row.companyAttendanceId
      }).then((res) => {
        if (res.data.success) {
          this.handleSearch()
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    submitAudit(row) {
      companyAttendanceSubmitAudit({
        companyAttendanceId: row.companyAttendanceId
      }).then((res) => {
        if (res.data.success) {
          this.handleSearch()
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    audit(row) {
      this.row = row
      this.dialogVisible = true
      this.asyncRoute.checkIdea = ''
      this.asyncRoute.pass = '1'
    },
    auditclick() {
      if (!this.asyncRoute.checkIdea && this.asyncRoute.pass == '2') {
        this.$Message.error('请填写审核意见')
        return
      }
      let pass = true;
      if (this.asyncRoute.pass == '2') {
        pass = false
      }
      companyAttendanceAudit({
        subjectId: this.row.companyAttendanceId,
        pass: pass,
        checkIdea: this.asyncRoute.checkIdea,
      }).then((res) => {
        if (res.data.success) {
          this.$Message.success(res.data.msg)
          this.dialogVisible = false
          this.handleSearch()
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    outs() {
      axios({
        baseURL: process.env.VUE_APP_BASE_URL,
        url: `org/auth/companyAttendanceRecord/batchDownload`,
        responseType: 'blob',
        method: 'get',
        params: {companyAttendanceIds: this.companyAttendanceIds},
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('getToken')
        },
      }).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res.data], {type: 'application/zip'})
        link.download = this.$moment(new Date()).format('YYYYMMDDHHmm')
        link.href = URL.createObjectURL(blob)
        link.click()
      })
    },
    out(row) {
      axios({
        baseURL: process.env.VUE_APP_BASE_URL,
        url: `org/auth/companyAttendanceRecord/export`,
        responseType: 'blob',
        method: 'get',
        params: {companyAttendanceId: row.companyAttendanceId},
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('getToken')
        },
      }).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
        link.style.display = 'none'
        link.download = '企业考勤明细信息.xlsx'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      })
    },
  }
}
</script>
<style lang="less">
.red {
  background-color: rgba(243, 12, 1, 0.48);
  color: rgb(0, 0, 0);
  padding: 8px;
}

.green {
  background-color: rgba(66, 165, 111, 0.5);
  padding: 8px;
  color: rgba(55, 55, 55);
}

.el-calendar-table td .el-calendar-day {
  padding: 0;
}

.el-calendar__header {
  display: none
}
</style>
